module.exports = __webpack_public_path__ + "img/metroid.c65d6dde.png";